(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["af-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function mount(root) {
      root.afUGCCleanup?.();
      const abort = new AbortController();
      const on = (node, name, handler, options = {}) => node?.addEventListener(name, handler, { ...options, signal: abort.signal });
      const track = root.querySelector('[data-ugc-track]');
      const cards = [...root.querySelectorAll('[data-ugc-card]')];
      const controls = root.querySelector('[data-ugc-controls]');
      const prev = root.querySelector('[data-ugc-prev]');
      const next = root.querySelector('[data-ugc-next]');
      const more = root.querySelector('[data-ugc-more]');
      const status = root.querySelector('[data-ugc-status]');
      const grid = root.dataset.layout === 'grid';
      const editor = root.dataset.editor === 'true';
      const chunk = Math.max(1, Number(root.dataset.initialCount) || 8);
      let shown = grid && !editor ? Math.min(chunk, cards.length) : cards.length;
      const update = () => {
        const overflow = track.scrollWidth - track.clientWidth;
        controls.hidden = grid || overflow < 2;
        prev.disabled = track.scrollLeft < 2;
        next.disabled = track.scrollLeft >= overflow - 2;
      };
      const reveal = () => {
        cards.forEach((card, i) => { card.hidden = grid && i >= shown; });
        more.hidden = !grid || shown >= cards.length || editor;
        const populated = cards.filter(card => !card.classList.contains('af-ugc-placeholder'));
        const visiblePopulated = populated.filter(card => !card.hidden).length;
        status.textContent = populated.length ? root.dataset.statusPattern.replace('__SHOWN__', String(visiblePopulated)).replace('__TOTAL__', String(populated.length)) : '';
        update();
      };
      const scroll = direction => {
        if (!cards.length) return;
        const distance = cards[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(track).gap) || 0);
        track.scrollBy({ left: direction * distance, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      on(prev, 'click', () => scroll(-1));
      on(next, 'click', () => scroll(1));
      on(more, 'click', () => {
        const firstNew = cards[shown];
        shown = Math.min(cards.length, shown + chunk);
        reveal();
        if (firstNew) { firstNew.tabIndex = -1; firstNew.focus({ preventScroll: true }); }
      });
      on(track, 'scroll', update, { passive: true });
      on(track, 'keydown', event => {
        if (grid || event.target !== track) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); scroll(event.key === 'ArrowRight' ? 1 : -1); }
      });
      const videos = [...root.querySelectorAll('video')];
      videos.forEach(video => on(video, 'play', () => {
        document.querySelectorAll('[data-af-ugc] video').forEach(other => { if (other !== video && !other.paused) other.pause(); });
      }));
      on(document, 'visibilitychange', () => { if (document.hidden) videos.forEach(video => video.pause()); });
      let resize;
      if (window.ResizeObserver) { resize = new ResizeObserver(update); resize.observe(track); }
      else on(window, 'resize', update);
      let visibility;
      if (window.IntersectionObserver) {
        visibility = new IntersectionObserver(entries => entries.forEach(entry => { if (!entry.isIntersecting && !entry.target.paused) entry.target.pause(); }), { threshold: 0.05 });
        videos.forEach(video => visibility.observe(video));
      }
      on(document, 'shopify:block:select', event => {
        const card = root.querySelector(`#UGCCard-${CSS.escape(event.detail.blockId)}`);
        if (card) card.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'auto' });
      });
      root.afUGCCleanup = () => { abort.abort(); resize?.disconnect(); visibility?.disconnect(); videos.forEach(video => { if (!video.paused) video.pause(); }); };
      reveal();
    }
    const init = scope => scope.querySelectorAll('[data-af-ugc]').forEach(mount);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
    else init(document);
    document.addEventListener('shopify:section:load', event => init(event.target));
    document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-af-ugc]').forEach(root => root.afUGCCleanup?.()));
  })();

  } catch(e) { console.error(e); }
})();
})();
